import React, { Component, ReactNode } from 'react';
import { Avatar, Badge } from 'antd';
import { connect } from 'react-redux';

import styles from './avatar.module.scss';
import { RootState } from '../../slices/rootReducer';
import { selectors as authSelectors } from '../../slices/auth';
import { IUser } from '../../slices/users/user';
import { getUserInitials } from './utils/string';

import { ReactComponent as SpyIcon } from '../../assets/sightx-icons/svg/icon-spy.svg';

interface IUserAvatarProps {
  user: IUser | null;
  impersonating: boolean;
}

class UserAvatar extends Component<IUserAvatarProps> {
  render(): ReactNode {
    let avatar;
    const { user, impersonating } = this.props;
    if (!user) {
      return null;
    }

    if (user.avatar) {
      avatar = <Avatar src={user.avatar} />;
    } else {
      const initials = getUserInitials(user);
      avatar = (
        <Avatar className={styles.profileButton}>
          {initials}
        </Avatar>
      );
    }

    if (impersonating) {
      return (
        <Badge offset={[-7, 3]} count={<SpyIcon className={styles.spyIcon} />}>
          {avatar}
        </Badge>
      );
    }
    return avatar;
  }
}

const mapStateToProps = (state: RootState) => ({
  user: authSelectors.getLoggedInUser(state),
  impersonating: !!authSelectors.getOriginalUser(state)
});

export default connect(mapStateToProps)(UserAvatar);
